export function DotGrid() {
  const dots: { x: number; y: number }[] = [];
  for (let x = 20; x <= 600; x += 30) {
    for (let y = 20; y <= 340; y += 30) {
      dots.push({ x, y });
    }
  }
  return (
    <g>
      {dots.map((d, i) => (
        <circle key={i} cx={d.x} cy={d.y} r={1} fill="hsl(0 0% 75% / 0.35)" />
      ))}
    </g>
  );
}
